import axios from 'axios'

const baseUrl = process.env.BASE_URL
// 创建用户
/**
 * 登录接口请求token与userinfo
 * @param data
 * 入参  code:"021gj0OV1om5PU0k9VNV1VMQNV1gj0OK"
 * 返回  {
 *          accessToken:'xxx',
 *          refreshToken:'xxx',
 *          userInfo:{}
 *       }
 */
export function loginByCode (data) {
  return axios.get('https://herman2.infiai.tech/weixin/code/62/', {
    params: data
  })
}
// 创建用户
export function createUser (data) {
  return axios.post(`${baseUrl}api/user/`, data)
}

// 获取会议室列表
export function conferencelist (date, data) {
  return axios.get(`${baseUrl}mros-api/meeting-room-list/?booking_date=${date}`, data)
}

// 提交新的预定记录
export function submitnew (data) {
  return axios.post(`${baseUrl}mros-api/reservation-list/`, data)
}

// 获取用户的预定记录
export function getuserreserve (id, data) {
  return axios.get(`${baseUrl}mros-api/reservation-list?user_id=${id}`, data)
}

//删除用户预订记录
export function deleteuserreserve (id, data) {
  return axios.delete(`${baseUrl}mros-api/reservation-list/?id=${id}`, data)
}

//获取用户id
export function getuseid (code, data) {
  return axios.get(`${baseUrl}mros-api/user-id/?code=${code}`, data)
}

// 获取部门
export function departmentlist (data) {
  return axios.get(`${baseUrl}mros-api/department-list`, data)
}

// 获取具体部门成员
export function departmentmember (id, data) {
  return axios.get(`${baseUrl}mros-api/employee-list?department_id=${id}`, data)
}


// WEBPACK FOOTER //
// ./src/api/index.js